import * as React from 'react'

import ErrorPic from '../images/website-out-of-poaps.png'
import { renderDescription } from '../displayErrorHelper'

type Props = {
  title: string
  description: any[]
  onBack: () => void
}

const WebsiteClaimError: React.FC<Props> = ({ title, description, onBack }) => {
  return (
    <div className="website-error-container">
      <img src={ErrorPic} alt="not found" />
      <div className="website-error-message-box">
        <h2>{title}</h2>
        <div>{renderDescription(description)}</div>
        <button type="button" className="btn" onClick={onBack}>
          Go Back
        </button>
      </div>
    </div>
  )
}

export default WebsiteClaimError
